/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_SourcesInputs */

const cs_reports_sources = /** @type {(inputs: Reports_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroje leadů`)
};

const en_reports_sources = /** @type {(inputs: Reports_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead sources`)
};

/**
* | output |
* | --- |
* | "Lead sources" |
*
* @param {Reports_SourcesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_sources = /** @type {((inputs?: Reports_SourcesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_SourcesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_sources(inputs)
	return cs_reports_sources(inputs)
});